/* Wiggle & Tickle — shared behaviour.
   Mirrors the interactions declared in the Claude Design components:
   announcement dismiss, add-to-cart feedback, newsletter signup,
   collection filter/sort state, featured carousel, reveal-on-scroll. */
(function () {
  'use strict';

  /* ---- Announcement bar ---- */
  var announce = document.querySelector('[data-announce] button');
  if (announce) {
    announce.addEventListener('click', function () {
      var bar = announce.parentNode;
      bar.style.transition = 'max-height .35s, padding .35s, opacity .3s';
      bar.style.maxHeight = '0';
      bar.style.padding = '0';
      bar.style.opacity = '0';
      setTimeout(function () { bar.remove(); }, 400);
    });
  }

  /* ---- Mobile menu ----
     The prototype simply hid the nav below 1024px with nothing behind it, so
     this drawer and its behaviour are new. */
  var menu = document.querySelector('[data-mobile-menu]');
  if (menu) {
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var lastMenuFocus = null;

    var openMenu = function () {
      lastMenuFocus = document.activeElement;
      menu.hidden = false;
      document.body.style.overflow = 'hidden';
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
      var close = menu.querySelector('[data-menu-close]');
      if (close && close.focus) close.focus();
    };

    var closeMenu = function () {
      menu.hidden = true;
      document.body.style.overflow = '';
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      if (lastMenuFocus && lastMenuFocus.focus) lastMenuFocus.focus();
    };

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-menu-toggle]')) {
        event.preventDefault();
        menu.hidden ? openMenu() : closeMenu();
        return;
      }
      /* The scrim carries data-menu-close too, so tapping outside closes. */
      if (event.target.closest('[data-menu-close]')) {
        event.preventDefault();
        closeMenu();
        return;
      }
      /* Following a link should not leave the drawer open behind it. */
      if (!menu.hidden && event.target.closest('[data-mobile-menu] a')) closeMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) closeMenu();
    });

    /* Returning to desktop width with the drawer open would leave the page
       unscrollable behind an invisible panel. */
    window.addEventListener('resize', function () {
      if (!menu.hidden && window.innerWidth > 1024) closeMenu();
    });
  }

  /* ---- Add to cart ----
     Handled for real by assets/cart.js against the Cart AJAX API. */

  /* ---- Newsletter signup ----
     A real {% form 'customer' %} now posts to Shopify and renders its own
     success and error states, so the mocked confirmation is gone. */

  /* ---- Collection filtering + sorting ----
     The prototype filtered DOM nodes in the browser, which silently breaks
     once a collection paginates: it can only ever filter the page you are
     looking at. Shopify's native filters drive this now — every filter and
     sort control is a real form/link that reloads the collection server-side,
     so counts, pagination and results always agree. See
     sections/collection.liquid and assets/collection-filters.js. */

  /* ---- Featured carousel ---- */
  var carousel = document.querySelector('[data-carousel]');
  if (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-slide]'));
    var nameEl = carousel.querySelector('[data-feat-name]');
    var descEl = carousel.querySelector('[data-feat-desc]');
    var curEl = carousel.querySelector('[data-feat-current]');
    var linkEl = carousel.querySelector('[data-feat-link]');
    var index = 0;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.style.opacity = i === index ? '1' : '0';
        s.style.transition = 'opacity .4s ease';
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      if (nameEl) nameEl.textContent = slides[index].dataset.name;
      if (descEl) descEl.textContent = slides[index].dataset.desc;
      if (curEl) curEl.textContent = index + 1;
      /* Each slide points at its own product, so the CTA has to follow. */
      if (linkEl) {
        var url = slides[index].dataset.url;
        if (url) {
          linkEl.href = url;
          linkEl.hidden = false;
        } else {
          linkEl.hidden = true;
        }
      }
    }
    var prev = carousel.querySelector('[data-feat-prev]');
    var next = carousel.querySelector('[data-feat-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    show(0);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(function () { show(index + 1); }, 5000);
    }
  }

  /* ---- Moment cards ----
     The track scrolls and snaps on its own; this only adds the arrows and
     the dots. One dot per scroll stop, not per card — a stop is each card
     that can land flush against the left edge. */
  document.querySelectorAll('[data-moments]').forEach(function (root) {
    var track = root.querySelector('[data-moments-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-moment]'));
    var prev = root.querySelector('[data-moments-prev]');
    var next = root.querySelector('[data-moments-next]');
    var dotsWrap = root.querySelector('[data-moments-dots]');
    if (!track || cards.length < 2) return;

    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;

    /* offsetLeft is relative to the track (it is position: relative), so the
       scroll position never leaks into these numbers. */
    var stops = cards
      .map(function (card) { return card.offsetLeft; })
      .filter(function (left) { return left <= track.scrollWidth - track.clientWidth + 1; });
    if (stops[stops.length - 1] !== track.scrollWidth - track.clientWidth) {
      stops.push(track.scrollWidth - track.clientWidth);
    }

    if (stops.length < 2) {
      root.classList.add('is-static');
      return;
    }

    var current = 0;
    var dots = stops.map(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'moments-dot';
      dot.setAttribute('aria-label', 'Go to moment ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); });
      if (dotsWrap) dotsWrap.appendChild(dot);
      return dot;
    });

    function nearestStop() {
      var best = 0;
      stops.forEach(function (left, i) {
        if (Math.abs(left - track.scrollLeft) < Math.abs(stops[best] - track.scrollLeft)) best = i;
      });
      return best;
    }

    function render() {
      current = nearestStop();
      if (prev) prev.setAttribute('aria-disabled', current === 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', current === stops.length - 1 ? 'true' : 'false');
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    function goTo(i) {
      var clamped = Math.max(0, Math.min(stops.length - 1, i));
      track.scrollTo({
        left: stops[clamped],
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; render(); });
    }, { passive: true });

    /* Card widths change with the viewport, so stops are only valid until
       the next resize; rebuild them rather than scaling the old ones. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        stops = cards
          .map(function (card) { return card.offsetLeft; })
          .filter(function (left) { return left <= track.scrollWidth - track.clientWidth + 1; });
        var end = track.scrollWidth - track.clientWidth;
        if (stops[stops.length - 1] !== end) stops.push(end);
        dots.forEach(function (dot, i) { dot.hidden = i >= stops.length; });
        render();
      }, 150);
    });

    render();
  });

  /* ---- Gallery filter ---- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var galCount = document.querySelector('[data-gallery-count]');
    var applyGallery = function (want) {
      var shown = 0;
      gallery.querySelectorAll('[data-cat]').forEach(function (item) {
        var ok = want === 'all' || item.dataset.cat === want;
        item.hidden = !ok;
        if (ok) shown++;
      });
      if (galCount) galCount.textContent = shown + " moments · filter by what you'd like to see";
    };
    document.querySelectorAll('[data-gallery-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-gallery-filter]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        applyGallery(btn.dataset.galleryFilter);
      });
    });
    applyGallery('all');
  }

  /* ---- Glossary: search + category filter ---- */
  var glossary = document.querySelector('[data-glossary]');
  if (glossary) {
    var gEntries = Array.prototype.slice.call(glossary.querySelectorAll('[data-entry]'));
    var gSearch = document.querySelector('[data-glossary-search]');
    var gCount = document.querySelector('[data-glossary-count]');
    var gEmpty = document.querySelector('[data-glossary-empty]');
    var gEmptyTerm = document.querySelector('[data-glossary-term]');
    var gCat = 'All';

    function renderGlossary() {
      var q = gSearch ? gSearch.value.trim().toLowerCase() : '';
      var shown = 0;
      gEntries.forEach(function (entry) {
        var catOk = gCat === 'All' || entry.dataset.entry === gCat;
        var textOk = !q || entry.textContent.toLowerCase().indexOf(q) !== -1;
        var ok = catOk && textOk;
        entry.hidden = !ok;
        if (ok) shown++;
      });
      if (gCount) gCount.textContent = shown + (shown === 1 ? ' entry' : ' entries');
      if (gEmpty) gEmpty.hidden = shown !== 0;
      if (gEmptyTerm) gEmptyTerm.textContent = q;
    }

    if (gSearch) gSearch.addEventListener('input', renderGlossary);
    document.querySelectorAll('[data-glossary-clear]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (gSearch) gSearch.value = '';
        gCat = 'All';
        document.querySelectorAll('[data-glossary-cat]').forEach(function (b) {
          b.classList.toggle('is-on', b.dataset.glossaryCat === 'All');
        });
        renderGlossary();
      });
    });
    document.querySelectorAll('[data-glossary-cat]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-glossary-cat]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        gCat = btn.dataset.glossaryCat;
        renderGlossary();
      });
    });
    renderGlossary();
  }

  /* ---- Help centre: FAQ topic tabs + order tracking + reason chips ---- */
  var helpFaqs = document.querySelectorAll('[data-help-topic]');
  if (helpFaqs.length) {
    var applyTopic = function (want) {
      helpFaqs.forEach(function (item, i) {
        var ok = item.dataset.helpTopic === want;
        item.hidden = !ok;
        item.open = ok && i === 0;
      });
      // open the first visible entry
      var first = Array.prototype.slice.call(helpFaqs).filter(function (f) { return !f.hidden; })[0];
      if (first) first.open = true;
    };
    document.querySelectorAll('[data-topic-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-topic-filter]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        applyTopic(btn.dataset.topicFilter);
      });
    });
    var initial = document.querySelector('[data-topic-filter].is-on');
    if (initial) applyTopic(initial.dataset.topicFilter);
  }

  /* ---- Order tracking ----
     The prototype always answered "Out for delivery ✓" regardless of input.
     Shopify has no storefront endpoint to look an order up by number alone,
     so the help centre now links to the customer account and the order status
     page instead of pretending to know. */

  document.querySelectorAll('[data-reason-group]').forEach(function (group) {
    group.querySelectorAll('[data-reason]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('[data-reason]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
      });
    });
  });

  /* ---- Where to buy: stock filter ----
     The prototype's postcode box only re-labelled the heading with whatever
     you typed and always claimed "Klang, Selangor" otherwise — it never
     measured distance. Proximity search needs geocoding, so the list is an
     honest directory and the count reflects what is actually shown. */
  var stores = document.querySelector('[data-stores]');
  if (stores) {
    var storeCards = Array.prototype.slice.call(stores.querySelectorAll('[data-stock]'));
    var heading = document.querySelector('[data-store-heading]');
    var mode = 'All stores';

    function renderStores() {
      var shown = 0;
      storeCards.forEach(function (card) {
        var ok = mode === 'All stores'
          || (mode === 'In stock only' && card.dataset.stock === 'in');
        card.hidden = !ok;
        if (ok) shown++;
      });
      if (heading) {
        heading.textContent = shown + (shown === 1 ? ' stockist' : ' stockists');
      }
    }

    document.querySelectorAll('[data-stock-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-stock-filter]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        mode = btn.dataset.stockFilter;
        renderStores();
      });
    });
    renderStores();
  }

  /* ---- Contact / trade / affiliate forms ----
     These are real {% form %} tags now. Shopify validates them server-side and
     renders its own success and error states, so the mocked "Sent ✓" is gone. */

  /* ---- Product page: variant + quantity ----
     Handled by assets/product-form.js, which selects real variants, keeps the
     hidden id input in sync, and respects availability. */

  /* ---- Affiliate earnings estimator ---- */
  var estimator = document.querySelector('[data-estimator]');
  if (estimator) {
    var clicksInput = estimator.querySelector('[data-clicks]');
    var aovInput = estimator.querySelector('[data-aov]');
    var clicksOut = estimator.querySelector('[data-clicks-out]');
    var aovOut = estimator.querySelector('[data-aov-out]');
    var ordersOut = estimator.querySelector('[data-orders-out]');
    var commissionOut = estimator.querySelector('[data-commission-out]');
    var annualOut = estimator.querySelector('[data-annual-out]');
    var rateOut = estimator.querySelector('[data-rate-out]');
    /* Tiers are merchant-editable, so read the starting rate off the
       pre-selected tier rather than assuming the prototype's 18%. */
    var activeTier = estimator.querySelector('[data-tier].is-on') || estimator.querySelector('[data-tier]');
    var rate = activeTier ? Number(activeTier.dataset.tier) : 18;
    var CONVERSION = 0.034;

    function calc() {
      var clicks = Number(clicksInput.value);
      var aov = Number(aovInput.value);
      var orders = Math.round(clicks * CONVERSION);
      var commission = Math.round(orders * aov * (rate / 100));
      clicksOut.textContent = clicks.toLocaleString();
      aovOut.textContent = 'RM ' + aov;
      ordersOut.textContent = orders;
      commissionOut.textContent = 'RM ' + commission.toLocaleString();
      annualOut.textContent = 'RM ' + (commission * 12).toLocaleString();
      rateOut.textContent = rate + '%';
    }

    clicksInput.addEventListener('input', calc);
    aovInput.addEventListener('input', calc);
    estimator.querySelectorAll('[data-tier]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        estimator.querySelectorAll('[data-tier]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        rate = Number(btn.dataset.tier);
        calc();
      });
    });
    calc();
  }

  /* ---- Back to top ---- */
  var top = document.getElementById('to-top');
  if (top) {
    window.addEventListener('scroll', function () {
      top.classList.toggle('on', window.scrollY > 500);
    }, { passive: true });
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- Reveal on scroll ---- */
  var revealables = document.querySelectorAll('.reveal');
  if (revealables.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('shown'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add('shown'); });
  }
})();
